exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error{color:darkred}ul.error{list-style-type:none;margin-bottom:5px}.open .vti__selection icon{transform:rotate(180deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4cb0da96","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/menu/EditProfileMenu.vue
// module id = ZJ6k
// module chunks = 0 1